import { getToken, getUser } from "../Utils/Common";
import { getAPICallWithParams } from "../axiosMethodCalls";

export const getGrowthChart = async (data) => {
  try {
    const response = await getAPICallWithParams(
      process.env.REACT_APP_LINK + "graphs/growth_chart",
      {
        requester: getUser(),
        token: getToken(),
        ...data, // growth_chart_type: [weight-chart, creatinine-chart]
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
